import { createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  root: {
    width: "100%",
    "& > div": {
      width: "100%",
      "&:not(:last-of-type)": {
        marginBottom: "12px",
      },
    },
  },
});
